import { render, staticRenderFns } from "./LabelCmp.vue?vue&type=template&id=9a38ee00&scoped=true&lang=pug&"
import script from "./LabelCmp.vue?vue&type=script&lang=js&"
export * from "./LabelCmp.vue?vue&type=script&lang=js&"
import style0 from "./LabelCmp.vue?vue&type=style&index=0&id=9a38ee00&prod&lang=scss&"
import style1 from "./LabelCmp.vue?vue&type=style&index=1&id=9a38ee00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a38ee00",
  null
  
)

export default component.exports